import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AboutUs } from "./AboutUs";
import { ContactUs } from "./ContactUs";
import NavScroll from "./Navbar";
import { Footer } from "./Footer";
import { AppDev } from "./AppDev";
import { WebDev } from "./WebDev";
import { NotFound } from "./NotFound";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <NavScroll />
      <Routes>
        {/* <Route path="home" element={<App />} /> */}
        <Route path="/" element={<App />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route path="web-development" element={<WebDev />} />
        <Route path="app-development" element={<AppDev />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
